export default __webpack_public_path__ + "static/media/arrow-mobile.5b976a1f.svg";